/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.22",
    versionName: "0.2.0-nightly.2025.12.22",
    versionChannel: "nightly",
    buildDate: "2025-12-22T00:08:08.559Z",
    commitHash: "e31f6a8a9fe3c6e731e4867be5b6d8454a710b1f",
};
